import React, { useEffect, useState } from 'react'
import styles from './index.scss'
interface PriceProps {
  exchangeType: number
  exchangePrice: number
  pointPrice: number
  exchangePriceSuffix: number
  className?: string
  hideZero?: boolean
  currencySymbol?: string
}
const index: React.FC<PriceProps> = ({
  exchangeType,
  exchangePrice,
  pointPrice,
  exchangePriceSuffix,
  className = '',
  hideZero = false,
  currencySymbol = '¥',
}) => {
  if (hideZero && !exchangePrice && !pointPrice) return <></>
  const [price, setPrice] = useState<{ int: string; float?: string }>()
  const renderCashSymbol = () => {
    if ([1, 5].includes(exchangeType)) return <span className={styles.symbol}>{currencySymbol || '¥'}</span>
  }
  const renderPointSymbol = () => {
    if ([2, 4, 5].includes(exchangeType)) return '积分'
  }
  if (exchangeType === 5) {
    return (
      <>
        {renderCashSymbol()}
        <span className={`plus ${className}`}>{exchangePrice}</span>+
        <span className={`plus ${className}`}>{pointPrice}</span>
        {renderPointSymbol()}
      </>
    )
  }
  const _price = [2, 4, 5].includes(exchangeType)
    ? pointPrice
    : [1, 5].includes(exchangeType)
    ? exchangePrice
    : undefined
  useEffect(() => {
    if (typeof _price === 'number') {
      const [int, float] = _price?.toString().split('.')
      setPrice({ int, float })
    }
  }, [_price])
  return (
    <>
      {renderCashSymbol()}
      {price?.int && <span className={`plus ${className}`}>{price.int}</span>}
      {price?.float && `.${price.float}`}
      {renderPointSymbol()}
      {exchangePriceSuffix == 1 && '起'}
    </>
  )
}

export default index
